import React from 'react';
import { textVariantStyleMap } from '../../v2BaseComponents/Text';
import { TextInput, Pressable, View, ViewStyle, StyleProp } from 'react-native';
import { colors } from '../../../utils/theme';
import { getSpacing } from '../../../utils/spacing';
import Icon from '../../v2BaseComponents/Icon';
import getBrowser from '../../../utils/getBrowser';
import { getIntl } from '../../../utils/intl';
import { useIsMobileLayout } from '../../../hooks/useIsMobileLayout';

const intl = getIntl('SearchPromptInput', {
    placeholder: 'Search or Ask the Assistant...',
});

export type SearchPromptInputOwnProps = {
    style?: StyleProp<ViewStyle>;
    onFocus: () => void;
};

export type SearchPromptInputProps = SearchPromptInputOwnProps;

const SearchPromptInput: React.FC<SearchPromptInputProps> = ({ style, onFocus }) => {
    const browser = getBrowser(navigator.userAgent);
    const isMobile = useIsMobileLayout();

    const textStyle = textVariantStyleMap['large-placeholder-text'];

    const getShadowProps = (): StyleProp<ViewStyle> => ({
        shadowColor: colors.Black,
        shadowOffset: {
            width: 0,
            height: isMobile ? 0.5 : 2,
        },
        shadowOpacity: 0.15,
        shadowRadius: 11,
    });

    return (
        <View style={[{ width: '100%', padding: 4 }, style]}>
            <Pressable onPress={onFocus} style={[{ alignSelf: 'stretch' }]} testID="prompt-profile-search-input">
                <View
                    style={[
                        {
                            borderRadius: 8,
                            display: 'flex',
                            flexDirection: 'row',
                            paddingVertical: getSpacing(4),
                            paddingHorizontal: getSpacing(6),
                            backgroundColor: colors['White'],
                            borderColor: colors['Grey-Light'],
                            borderWidth: 1,
                            ...({ fontSynthesis: browser === 'Safari' ? 'style' : undefined } as any),
                            ...(getShadowProps() as any),
                        },
                    ]}
                >
                    <View style={{ alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center' }}>
                        <Icon name="Search" color="Gray-Text" size="profile-search-prompt-icon" />
                    </View>
                    <TextInput
                        style={{
                            ...textStyle,
                            lineHeight: 26,
                            paddingHorizontal: getSpacing(3),
                            paddingVertical: getSpacing(1),
                            flex: 1,
                            borderColor: 'transparent',
                            ...({ outlineStyle: 'none' } as any),
                            testID: 'prompt-chat-input',
                            overflow: 'show',
                            alignSelf: 'center',
                        }}
                        onFocus={() => {
                            onFocus?.();
                        }}
                        value={''}
                        placeholder={intl('placeholder')}
                        onChange={() => {}}
                    />

                    <View
                        style={{
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: 36,
                            height: 36,
                            borderRadius: 18,
                            backgroundColor: colors['Chat-Input-Button-Default'],
                        }}
                    >
                        <View style={{ paddingRight: getSpacing(1), paddingTop: getSpacing(1) }}>
                            <Icon name="Send" color="White" size="chat-button-icon" />
                        </View>
                    </View>
                </View>
            </Pressable>
        </View>
    );
};

export default React.memo(SearchPromptInput);
